module.exports = __webpack_public_path__ + "static/media/heart.3648117f.svg";